import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import DatePicker from '../components/DatePicker/DatePicker'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import ItemMaterials from './ItemMaterials'

export interface WorkOrderEditFormData {
  itemId: string
  line: string
  salesOrder: string
  quantity: string
  adjustmentQuantity: string
  productionDate: string
}

interface WorkOrderEditFormProps extends WorkOrderEditFormData {
  onInputChange: (name: string, value: string) => void
  onDateChange: (name: string, date: string) => void
  onSaveClick: () => void
}

export default class WorkOrderEditForm
  extends Component<WorkOrderEditFormProps> {
  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Edit Work Order")}
          doc='work-orders-edit-work-order' />
        <Row column={2}>
          <InputText
            name="line"
            value={this.props.line}
            label={i18n("Line number")}
            onChange={this.props.onInputChange} />
          <InputText
            name="salesOrder"
            value={this.props.salesOrder}
            label={i18n("Sales order")}
            onChange={this.props.onInputChange} />
        </Row>
        <Row column={2}>
          <InputText
            name="quantity"
            value={this.props.quantity}
            label={i18n("Quantity")}
            onChange={this.props.onInputChange} />
          <InputText
            name="adjustmentQuantity"
            value={this.props.adjustmentQuantity}
            label={i18n("Adjustment quantity")}
            onChange={this.props.onInputChange} />
        </Row>
        <Row column={2}>
          <DatePicker
            name="productionDate"
            value={this.props.productionDate}
            label={i18n("Production date")}
            onChange={this.props.onDateChange} />
        </Row>
        <ItemMaterials
          id={Number(this.props.itemId)}
          quantity={Number(this.props.quantity)} />
        <CardButton
          proceedText={i18n("Save")}
          cancelText={i18n("Cancel")}
          onProceedClick={this.props.onSaveClick} />
      </Card>
    )
  }
}
